import React from 'react';
import { Link } from 'react-router-dom';

const ContentRemovalPolicy = () => (
  <>
    <h2>NiteFlirt CONTENT REMOVAL POLICY</h2>

    <p>
      <strong>
        By directing your browser to this website, you accept and agree to this Content Removal Policy which forms part of the NiteFlirt User Agreement. Please read it carefully.
      </strong>
      &nbsp;All definitions used in the Terms of Service apply to this Content Removal Policy.
    </p>

    <p>
      We have the absolute right to remove any Content that we believe, in our sole discretion, may violate any law or the NiteFlirt User Agreement. We comply with all applicable laws regarding the use of proportionate measures to quickly remove illegal Content when we become aware it is on our Site. We are not responsible for any loss you claim to have suffered because of any action we take, in accordance with our Terms of Service and the NiteFlirt User Agreement, to suspend or remove Content. Members will not be refunded for illegal Content purchased by a Member that is subsequently removed from the Member’s account.
    </p>

    <p>
      <u>Content Moderation and Removal:</u>
      &nbsp;We utilize third party content moderation technology in addition to human moderation to actively review and monitor all content uploaded to the Site, including text, audio, images and videos. All Content is reviewed and regularly monitored to ensure all Content complies with the NiteFlirt User Agreement and applicable laws. Any violative Content, including without limitation, Content that is harmful, unlawful, offensive, or otherwise objectionable, will be rejected and/or immediately removed from the Site. If you identify a Flirt or Member you believe to be violating any of the Terms of Service or NiteFlirt Rules, please immediately report it by emailing&nbsp;
      <a href="mailto:support@niteflirt.com">support@niteflirt.com</a>
      .
    </p>

    <p>
      <u>Copyright/DMCA Takedown Requests:</u>
      &nbsp;To make a copyright infringement complaint, or to submit a DMCA Takedown request, please follow the procedure set forth in our Terms of Service,&nbsp;
      <Link to="/help/tos#DMCA">HERE</Link>
      .
    </p>

    <p>
      <u>Non-Consensual Use of Name, Image or Likeness:</u>
      &nbsp;We have a strong policy against non-consensual production and/or distribution of any individual’s image, voice or likeness (including without limitation unauthorized or unconsented to videos, audio recordings or images, doxing, blackmail, exploitation, revenge porn etc.) If you believe the Site, or any Member or Flirt, is exhibiting, selling, offering or disseminating material in which you are depicted, and which you did not provide your consent for public dissemination, purchase or download by others, or for which you have revoked your consent, please follow the procedure set forth in our Terms of Service,&nbsp;
      <Link to="/help/tos#unauthimages">HERE</Link>
      .
    </p>

    <p>
      <u>Requests by Flirts:</u>
      &nbsp;You may request that we delete Content submitted by you by contacting us at&nbsp;
      <a href="mailto:support@niteflirt.com">support@niteflirt.com</a>
      . Note that we reserve the right to retain a copy of the Content in connection with our age verification requirements and/or other legal obligations. Note also that any Content purchased by Members prior to the date of your request for removal will remain in the Member accounts of such Members. We are not responsible for any copies or reproductions of Content, whether authorized or unauthorized.
    </p>

    <p>
      For any other requests for removal of Content, please email us at&nbsp;
      <a href="mailto:support@niteflirt.com">support@niteflirt.com</a>
      . Include enough information so we can investigate the removal request, such as name of Member or Flirt, date and time of identification and any relevant URLs. If a request is missing important information, we may not be able to properly consider it.
    </p>

    <p>
      We review all requests for content removal as soon as practicable but in no event more than seven (7) business days.
    </p>
  </>
);

export default ContentRemovalPolicy;
